import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { ApplianceDetailsFormValue } from './appliance-details-form-value.type';
import { CmsApplianceDetailsForm } from './cms-appliance-details-form.interface';

export interface ApplianceDetailsFormConfig {
  applianceMaximumAge: Date;
  clientBrandCode?: ClientBrandCode;
  cmsData: CmsApplianceDetailsForm;
  initialValue: Partial<ApplianceDetailsFormValue>;
}
